'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../providers/ClaimBuilder/index.js');
var ItemCardClaims = require('../../components/ItemCardClaims.js');
var Box = require('../../components/layout/Box/Box.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PackageSelectionCardItems = _ref => {
  let {
    shipment
  } = _ref;
  const {
    getFullItemDetails
  } = index.useClaimBuilder();
  return /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 4,
    style: {
      marginTop: '0.5rem',
      width: '100%'
    }
  }, shipment.items.map(item => {
    const itemDetails = getFullItemDetails(item.itemRefId, shipment.id);
    if (!itemDetails) return null;
    return /*#__PURE__*/React__default["default"].createElement(ItemCardClaims["default"], {
      key: item.itemRefId,
      itemDetails: itemDetails,
      layout: "horizontal"
    });
  }));
};

exports["default"] = PackageSelectionCardItems;
